/**
 * Normaliza una URL a su pathname comparable:
 *  - elimina esquema + host si la URL es absoluta;
 *  - elimina query (`?`) y fragmento (`#`);
 *  - elimina el/los slash(es) final(es).
 *
 * Compartida por las configuraciones que identifican operaciones por ruta
 * (decimals-header, encrypted-endpoints) sin depender del dominio del ambiente.
 */
export function normalizePath(url: string): string {
  if (!url) {
    return '';
  }
  const withoutOrigin = url.replace(/^[a-z][a-z0-9+.-]*:\/\/[^/]+/i, '');
  const pathOnly = withoutOrigin.split('?')[0].split('#')[0];
  return pathOnly.replace(/\/+$/, '');
}
